import { styled } from '@mui/material/styles';

interface Props {
  width?: string;
}

export const PrimaryStyledButton = styled('button')<Props & { disabled?: boolean }>(({ width, disabled }) => ({
  boxSizing: 'border-box',
  border: '2px solid #ff6600',
  backgroundColor: '#ff6600',
  color: 'white',
  textShadow: '-1px 0 gray, 0 1px gray, 1px 0 gray, 0 -1px gray',
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.5 : 1,
  width: width || 'auto',
  maxWidth: '100%',
  '&:hover': disabled ? {} : {
    backgroundColor: '#aa4400',
    border: '2px solid #aa4400',
  },
  borderWidth: '2px',
  borderRadius: '12px',
  padding: '14px 28px',
  margin: '6px',
  fontSize: '16px',
}));

export const SecondaryStyledButton = styled('button')<Props & { disabled?: boolean }>(({ theme, width, disabled }) => ({
  boxSizing: 'border-box',
  backgroundColor: 'transparent',
  color: 'inherit',
  border: '1px solid currentColor',
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.5 : 1,
  width: width || 'auto',
  borderRadius: '12px',
  padding: '8px 16px',
  margin: '6px',
  fontSize: '16px',
  '&:hover': disabled ? {} : {
    backgroundColor: theme.palette.grey[100],
  },
}));
